import { __extends } from "tslib";
import { ImageStretchOptions_$type } from "./ImageStretchOptions";
import { EditorType_$type } from "./EditorType";
import { IgrColumn } from "./igr-column";
import { ImageColumn } from "./ImageColumn";
import { ensureEnum } from "igniteui-react-core";
/**
 * Represents an Image grid column, used to allow the developer to display an image in a cell.
*/
var IgrImageColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrImageColumn, _super);
    function IgrImageColumn(props) {
        return _super.call(this, props) || this;
    }
    IgrImageColumn.prototype.createImplementation = function () {
        return new ImageColumn();
    };
    Object.defineProperty(IgrImageColumn.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrImageColumn.prototype, "imageStretchOption", {
        /**
         * Gets or sets the stretch option to use when rendering images
        */
        get: function () {
            return this.i.kz;
        },
        set: function (v) {
            this.i.kz = ensureEnum(ImageStretchOptions_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrImageColumn.prototype, "editorType", {
        /**
         * Gets or sets the editor type used for editing cells in this column.
        */
        get: function () {
            return this.i.kv;
        },
        set: function (v) {
            this.i.kv = ensureEnum(EditorType_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrImageColumn.prototype, "editorDataSource", {
        /**
         * Gets or sets the ComboBox data source.
        */
        get: function () {
            return this.i.k0;
        },
        set: function (v) {
            this.i.k0 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrImageColumn.prototype, "editorTextField", {
        /**
         * Gets or sets the ComboBox text field.
        */
        get: function () {
            return this.i.k1;
        },
        set: function (v) {
            this.i.k1 = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrImageColumn.prototype, "editorValueField", {
        /**
         * Gets or sets the ComboBox value field.
        */
        get: function () {
            return this.i.ku;
        },
        set: function (v) {
            if (v && !Array.isArray(v) && typeof (v) == "string") {
                var re = /\s*(?:,|\s|$)\s*/gm;
                v = v.split(re);
            }
            this.i.ku = v;
        },
        enumerable: false,
        configurable: true
    });
    return IgrImageColumn;
}(IgrColumn));
export { IgrImageColumn };
//# sourceMappingURL=igr-image-column.js.map
